import type { CellContext } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTableContext } from '../providers/TableProvider';
import { isCellEditable } from '../utils';

export const DefaultCell = <T,>({
  getValue,
  row: { index },
  column: {
    id,
    columnDef: { meta, header },
  },
  cell,
}: CellContext<T, unknown>) => {
  const { table } = useTableContext();

  const initialValue = getValue() as string;
  const [value, setValue] = useState<string>(initialValue);

  const onBlur = () => {
    table.options.meta?.updateData(index, { id: value });
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  let placeholder = '';
  if (meta?.placeholder) {
    placeholder = meta.placeholder;
  } else if (typeof header === 'string') {
    placeholder = header;
  }

  if (!isCellEditable(meta?.editable, cell)) {
    return <span>{value}</span>;
  }

  return (
    <Input
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={onBlur}
      type="text"
      placeholder={placeholder}
    />
  );
};

const Input = styled.input`
  :focus-visible {
    outline: none;
  }
`;
